import React, { useEffect } from "react";
import ProfileHeader from "./components/ProfileHeader";
import { Tabs } from "@public/ui-toolkit/src";
import AllocatorHomeTab from "./AllocatorHomeTab";
import AllocatorAboutTab from "./AllocatorAboutTab";
import { useQuery } from "../../utils/CustomHook";
import {
  getProfileDetail,
  getAllocatorStrategy,
  getCompanyPostFeed,
  getCompanyUsersAction,
  createAllocatorNetworks,
  updateAllocatorNetworks,
  deleteAllocatorNetwork
} from "./actions";
import { useDispatch, useSelector } from "react-redux";



const AllocatorProfile = ({ match }) => {
  const query = useQuery();
  const dispatch = useDispatch();

  const tenantId = match.params.id;

  const fundProfileDetails = useSelector((state) => state.allocatorProfile);
  const { page, perPage } = fundProfileDetails;

  useEffect(() => {
    const tab = query.get("tab");
    if (tab) {
      let tabElement = document.getElementById(tab);
      tabElement.click();
    }
  }, []);

  useEffect(() => {
    dispatch(getProfileDetail(tenantId));
    dispatch(getCompanyUsersAction(tenantId))
  }, [tenantId]);
  useEffect(() => {
    getCurrentCompanyPostFeed(page, perPage);
  }, [dispatch])
  useEffect(() => {
    dispatch(getAllocatorStrategy());
  }, []);

  const getCurrentCompanyPostFeed = (page, perPage) => {
    dispatch(getCompanyPostFeed({ tenantId: tenantId, page: page, perPage: perPage }));
  }
  const createAllocatorNetwork = (values) => {
    dispatch(createAllocatorNetworks(values))
  }

  const updateAllocatorNetwork = (values) => {
    dispatch(updateAllocatorNetworks(values))
  }

  const deleteAllocatorNetworks = (value) => {
    dispatch(deleteAllocatorNetwork(value))
  }

  return (
    <main>
      <div className="main-inner">
        <div className="mt-5" style={{ marginRight: "100px", marginLeft: "100px" }}>
          <ProfileHeader 
          fundProfileDetails={fundProfileDetails}
           id = {tenantId}
           createAllocatorNetwork = {createAllocatorNetwork}
           updateAllocatorNetwork = {updateAllocatorNetwork}
           deleteAllocatorNetworks = {deleteAllocatorNetworks}
            />
          <div className="profile-bottom-col mt-xl-4 mt-2 border-top">
            <nav>
              <div
                className="nav nav-tabs hf-nav-tabs"
                id="nav-tab"
                role="tablist"
              >
                <Tabs
                  tabName="Home"
                  tabType="primary"
                  id="nav-home-tab"
                  target="#nav-home"
                  controls="nav-home"
                  ariaSelected="true"
                />
                <Tabs
                  tabName="About"
                  id="nav-about-tab"
                  target="#nav-about"
                  controls="nav-about"
                  ariaSelected="true"
                />
              </div>
            </nav>
          </div>
          <div className="tab-content" id="nav-tabContent">
            <AllocatorHomeTab
              fundProfileDetails={fundProfileDetails}
              getCurrentCompanyPostFeed={getCurrentCompanyPostFeed}
            />
            <AllocatorAboutTab
              fundProfileDetails={fundProfileDetails}
              loading={fundProfileDetails.loading}
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default AllocatorProfile;
